var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-panel" }, [
    _c(
      "ul",
      { staticClass: "menu-panel-container" },
      _vm._l(_vm.menus, function(item) {
        return _c(
          "li",
          {
            key: item.id,
            staticClass: "menu-panel-item",
            style: { width: _vm.itemW },
            on: {
              click: function($event) {
                _vm.itemClicked(item)
              }
            }
          },
          [
            _c("img", {
              staticClass: "menu-icon",
              style: { width: _vm.menuIconSize, height: _vm.menuIconSize },
              attrs: { src: item.commont }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "menu-title" }, [
              _vm._v(_vm._s(item.adName))
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }